import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";
import {UserAgentViewModel} from "../../models/user-agent.view-model";

export class AppNotificationDisplayModel extends BaseWidgetDisplayModel {
  @observable shouldRenderNotificationApproval: Boolean;
  @observable shouldRenderSecondNoticeMessage: Boolean;
  @observable userAllowedNotification: Boolean;
  @observable trigger: String;
  @observable websiteNotifications: Number;

  constructor(userAgent: UserAgentViewModel) {
    super();

    this.userAgent = userAgent;
    this.shouldRenderNotificationApproval = false;
    this.shouldRenderSecondNoticeMessage = false;
    this.userAllowedNotification = false;
    this.trigger = '';
    this.websiteNotifications = -1;

    makeObservable(this);
  }

  get allowNotifications() {
    return this.userAgent.isChrome && ('Notification' in window);
  }
}
